export default __webpack_public_path__ + "static/media/github.dff5514e.png";